const loginShape = new Map();

loginShape.set('email', {
  width: '16',
  placeholder: 'common.email',
  label: 'common.email',
  required: true,
});

loginShape.set('password', {
  width: '16',
  placeholder: 'common.password',
  label: 'common.password',
  type: 'password',
  required: true,
});

export default loginShape;



// WEBPACK FOOTER //
// ./src/shapes/loginShape.js